import React, { Component, Fragment } from "react";
import { setLoader, setDeeplink, setParams } from "../../../../redux/actions";
import { connect } from "react-redux";
import {
  Row,
  Alert,
  Card,
  CardTitle,
  CardBody,
  Progress
} from "reactstrap";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import _axios from "../../../../libs/axios";
import { NotificationManager } from "../../../../components/common/react-notifications";
import ChartCard from "../../../../components/utils/ChartCard";
import AppLocale from "../../../../config/lang";
import { objToQueryString } from "../../../../helpers/Utils";
import { DoughnutChart } from "../../../../components/charts";
import { ThemeColors } from '../../../../helpers/ThemeColors';
import FormCustom from "../../../../components/utils/FormCustom";
import dateRange from "../../../../components/utils/DateRange"

const colors = ThemeColors();
const defaultValue = [
  {Key: "", Value: 0}
]

class AdmStats extends Component {
  constructor(props) {
    super(props);
    this.M = "admStats."
    this.state = {
      formFields: [],
      filters: null,
      progressBar: false,
      conversationsData: defaultValue,
      conversationsRatesData: defaultValue,
      topFlowsData: {
        labels: ['...', '...', '...'],
        datasets: [
          {
            label: '',
            borderColor: [colors.themeColor3, colors.themeColor2, colors.themeColor1],
            backgroundColor: [
              colors.themeColor3_10,
              colors.themeColor2_10,
              colors.themeColor1_10,
            ],
            borderWidth: 2,
            data: [],
          },
        ],
      },
      answeredQueriesData: [],
      totalConversations: null,
      totalFlowsComplete: null,
      totalFlowsPending: null,
      totalMessages: null
    }
  }

  UNSAFE_componentWillMount() {
    this.createForm()
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.filters?.from && !prevState.filters?.to && this.state.filters?.from && this.state.filters?.to) {
      this.getData();
    }
  }

  componentWillUnmount() {
    this.props.setParams(null)
  }

  createForm () {
    let fields = dateRange(
      {
        type: "daterange",
        range: {
          value: 0
        }
      },
    )

    fields = [...fields,
      {
        col: 3,
        name: "btnFilter",
        type: "button",
        label: 'Filter',
        onClick: () => this.getData()
      }
    ]

    this.setState({ formFields: fields })
  }

  getData() {
    const {from, to} = this.state.filters
    if (!from && !to) return
    const params = {
      from,
      to
    }
    const query = objToQueryString(params)
    this.setState({
      conversationsData: defaultValue,
      conversationsRatesData: defaultValue
    })
    _axios
      .get(`admConversations/dashboard?${query}`)
      .then(r => {
        if (r.status >= 0) {
          let { 
            chartConversations, chartFlows, pieFlows, totalConversations,
            totalFlowsComplete, totalFlowsPending, totalMessages, chartUnanswered 
          } = r.data

          const pieFlowsConfig = () => {
            const obj = {
              labels: [],
              datasets: [
                {
                  label: '',
                  borderColor: [colors.themeColor3, colors.themeColor2, colors.themeColor1],
                  backgroundColor: [
                    colors.themeColor3_10,
                    colors.themeColor2_10,
                    colors.themeColor1_10,
                  ],
                  borderWidth: 2,
                  data: [],
                },
              ]
            }

            if (pieFlows) {
              pieFlows.forEach(item => {
                obj.labels.push(item.Key)
                obj.datasets[0].data.push(item.Value)
              })
            }
            return obj
          }

          // Map chartUnanswered to answeredQueriesData format
          const unansweredQueries = chartUnanswered.map(item => ({
            title: item.Key,
            status: item.Value.m_Item1,
            total: item.Value.m_Item2
          }))

          this.setState({
            ...(chartConversations.length > 0 && {
              conversationsData: chartConversations
            }),
            ...(chartFlows.length > 0 && {
              conversationsRatesData: chartFlows
            }),
            topFlowsData: pieFlowsConfig(),
            answeredQueriesData: unansweredQueries,
            totalConversations,
            totalFlowsComplete,
            totalFlowsPending,
            totalMessages
          });
        } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
        this.setState({ progressBar: false })
      })
  }

  listenStatesForm = (s) => {
    this.setState({filters: s})
  }

  render() {
    const {
      conversationsData, conversationsRatesData, topFlowsData, answeredQueriesData,
      totalMessages, totalConversations, totalFlowsComplete, totalFlowsPending
    } = this.state
    const { locale, params } = this.props
    const L = AppLocale[locale].messages
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx xxs="12" xxl="6">
                <h1>Stats</h1>
              </Colxx>
            </Row>
          </Colxx>
        </Row>

        {params?.setupMsg && <Alert className="rounded" color="warning">{params.setupMsg}</Alert>}

        <Row>
          <Colxx lg="12" xl="12" className="mb-4">
            <FormCustom
              id={"form-filters-stats"}
              fields={this.state.formFields}
              listenStates={this.listenStatesForm}
              didUpdateStates={true}
            />
          </Colxx>
        </Row>

        <Row>
          <Colxx lg="12" xl="6" className="mb-4">
            <ChartCard
              data={conversationsData}
              L= {L}
              title="Conversations"
              yAxesMax={Math.ceil(Math.max(...conversationsData.map(item => item.Value)) * 1.05)}
            />
          </Colxx>
          <Colxx lg="12" xl="6" className="mb-4">
            <ChartCard
              data={conversationsRatesData}
              L= {L}
              title="Completed flows"
              yAxesMax={Math.ceil(Math.max(...conversationsRatesData.map(item => item.Value)) * 1.05)}
            />
          </Colxx>
        </Row>

        <Row>
          <Colxx xl="4" lg="6" md="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle>
                  Top {topFlowsData?.labels?.length} flows
                </CardTitle>
                <div className="dashboard-donut-chart">
                  <DoughnutChart shadow data={topFlowsData} />
                </div>
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="4" lg="6" md="12" className="mb-4">
            <Card className={"dashboard-progress"}>
              <CardBody>
                <CardTitle>
                  Conversations handled by Looc<br></br>
                  <span className="text-muted text-small">
                    Light color = escalated to human
                  </span>    
                </CardTitle>
                           
                {answeredQueriesData.map((s, index) => {
                  return (
                    <div key={index} className="mb-4">
                      <p className="mb-2">
                        {s.title}
                        <span className="float-right text-muted">
                          {s.status}/{s.total}
                        </span>
                      </p>
                      <Progress value={(s.status / s.total) * 100} />
                    </div>
                  );
                })}
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="4" lg="12" md="12">
            <Row>
              <Colxx xxs="6" className="mb-4">
                <Card className={"dashboard-small-chart-analytics"}>
                  <CardBody className="d-flex justify-content-center align-items-center">
                    <div className="text-center">
                      <h1 className="text-primary">{totalMessages}</h1>
                      <p>Total<br/>Messages</p>
                    </div>
                  </CardBody>
                </Card>
              </Colxx>
              <Colxx xxs="6" className="mb-4">
                <Card className={"dashboard-small-chart-analytics"}>
                  <CardBody className="d-flex justify-content-center align-items-center">
                    <div className="text-center">
                      <h1 className="text-primary">{totalConversations}</h1>
                      <p>Total<br/>Conversations</p>
                    </div>
                  </CardBody>
                </Card>
              </Colxx>
              <Colxx xxs="6" className="mb-4">
                <Card className={"dashboard-small-chart-analytics"}>
                  <CardBody className="d-flex justify-content-center align-items-center">
                    <div className="text-center">
                      <h1 className="text-primary">{totalFlowsComplete}</h1>
                      <p>Completed<br/>Flows</p>
                    </div>
                  </CardBody>
                </Card>
              </Colxx>
              <Colxx xxs="6" className="mb-4">
                <Card className={"dashboard-small-chart-analytics"}>
                  <CardBody className="d-flex justify-content-center align-items-center">
                    <div className="text-center">
                      <h1 className="text-primary">{totalFlowsPending}</h1>
                      <p>Incomplete<br/>Flows</p>
                    </div>
                  </CardBody>
                </Card>
              </Colxx>
            </Row>
          </Colxx>
        </Row>
      </Fragment>
    )
  }
}

const mapStateToProps = ({ settings, menu, utils, authUser }) => {
  const { menuItems } = menu
  const { locale } = settings
  const { deepLink, params } = utils
  const { userAdmin } = authUser
  return { locale, menuItems, deepLink, params, userAdmin }
}

export default connect(mapStateToProps, { setLoader, setDeeplink, setParams })(AdmStats);